import React from 'react';
import PropTypes from 'prop-types';

import styles from './capturedevice.scss';

class CheckpointStatus extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.node,
    };

    static defaultProps = {
        className: 'loading',
    };

    render() {
        const { className, children } = this.props;

        return (
            <p className={`${styles.checkpointStatus} ${styles[className]}`}>
                {children}
            </p>
        );
    }
}

export default CheckpointStatus;
